import { useTranslation } from 'react-i18next'
import { type Route } from './+types/route'
import { Article } from '~/components/article.tsx'
import { Cols } from '~/components/cols.tsx'
import { Gradient } from '~/components/gradients.tsx'
import { Layout } from '~/components/layout.tsx'
import { Markdown } from '~/components/markdown.tsx'
import { api } from '~/utils/gql-client.server.ts'
import { fallbackLng, supportedLngs } from '~/utils/i18n.ts'
import i18next from '~/utils/i18next.server.ts'
import { markdown } from '~/utils/markdown.server.ts'
import { generateMeta, type MetaProps } from '~/utils/meta.ts'
import { getPageState } from '~/utils/page-state.ts'

export function meta({ data }: Route.MetaArgs) {
  return generateMeta(data?.metaProps as MetaProps)
}

export let handle = {
  i18n: 'terms',
}

export async function loader({ request }: Route.LoaderArgs) {
  const pageState = await getPageState(request)

  const t = await i18next.getFixedT(pageState.locale ?? fallbackLng, 'terms')

  const metaProps: MetaProps = {
    seo: {
      metaTitle: t('terms_meta_title'),
      metaDescription: t('terms_meta_description'),
    },
    pageState: pageState,
    localizations: supportedLngs,
  }

  const { terms } = await api.Terms({
    language: pageState.locale ?? fallbackLng,
  })

  return {
    metaProps,
    terms: {
      transformedText: markdown(terms?.text ?? ''),
      ...terms,
    },
  }
}

export default function Terms({ loaderData }: Route.ComponentProps) {
  const { t } = useTranslation(['terms'])
  const { terms } = loaderData

  return (
    <Layout>
      <div className="relative overflow-hidden py-32">
        <Gradient />

        <div className="relative z-10 container">
          <Cols size="10">
            <div className="flex flex-col gap-6">
              <h1 className="font-display text-display-60 leading-tight font-extrabold text-text-default uppercase italic">
                {t('title')}
              </h1>
            </div>
          </Cols>
        </div>
      </div>

      <div className="container">
        <Cols size="10" className="py-24">
          <Article>
            <Markdown content={terms.transformedText} />
          </Article>
        </Cols>
      </div>
    </Layout>
  )
}
